import * as yup from "yup"
import React from "react"
import SettingSection from "./setting-section"
import { User } from "lucide-react"
import { IconPassword, IconPasswordUser } from "@tabler/icons-react"
import { useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { useChangePasswordMutation } from "../../account/store/account.query"
import { useNavigate } from "react-router-dom"
import { Button, PasswordInput } from "@mantine/core"
import { useTranslation } from "react-i18next"

const ChangePasswordComponent = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const schema = yup
    .object()
    .shape({
      currentPassword: yup
        .string()
        .min(8, t("minValidation", { count: 8, field: t("currentPassword") }))
        .max(25, t("maxValidation", { count: 25, field: t("currentPassword") }))
        .required(t("requiredValidation", { field: t("currentPassword") })),
      password: yup
        .string()
        .min(8, t("minValidation", { count: 8, field: t("newPassword") }))
        .max(25, t("maxValidation", { count: 25, field: t("newPassword") }))
        .required(t("requiredValidation", { field: t("newPassword") })),
      confirmPassword: yup
        .string()
        .min(8, t("minValidation", { count: 8, field: t("confirmPassword") }))
        .max(25, t("maxValidation", { count: 25, field: t("confirmPassword") }))
        .test("", t("confirmPasswordDesc"), (value) => {
          if (getValues("password") === value) {
            return true
          } else {
            return false
          }
        })
        .required(t("requiredValidation", { field: t("confirmPassword") })),
    })
    .required()

  const defaultValue = {
    currentPassword: "",
    password: "",
    confirmPassword: "",
  }
  const [changePassword, changePasswordResponse] = useChangePasswordMutation()

  const {
    register,
    handleSubmit,
    reset,
    getValues,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: defaultValue,
    mode: "all",
  })

  const onSubmit = (data: any) => {
    changePassword(data).then((response: any) => {
      if (!response?.error) {
        navigate("/")
      }
    })
  }

  const onError = (error: any) => {}
  return (
    <SettingSection icon={IconPasswordUser} title={t("changePassword")}>
      <div className="flex flex-col sm:flex-row items-center mb-6">
        <form
          onSubmit={handleSubmit(onSubmit, onError)}
          className="w-full mx-[25%]"
        >
          <PasswordInput
            placeholder={t("currentPassword")}
            label={t("currentPassword")}
            classNames={{ label: "text-gray-200" }}
            error={
              errors?.currentPassword && `${errors?.currentPassword?.message}`
            }
            {...register("currentPassword")}
            withAsterisk
          />
          <PasswordInput
            placeholder={t("newPassword")}
            label={t("newPassword")}
            classNames={{ label: "text-gray-200" }}
            error={errors?.password && `${errors?.password?.message}`}
            {...register("password")}
            withAsterisk
          />
          <PasswordInput
            placeholder={t("confirmPassword")}
            label={t("confirmPassword")}
            classNames={{
              label: "text-gray-200",
              description: "text-white-200",
            }}
            description={t("confirmPasswordDesc")}
            withAsterisk
            error={
              errors?.confirmPassword && `${errors?.confirmPassword?.message}`
            }
            {...register("confirmPassword")}
          />

          <Button
            variant="filled"
            className="bg-primary w-40 text-white mt-8"
            type="submit"
            classNames={{ label: "flex space-x-1" }}
            size={"xs"}
            loading={changePasswordResponse?.isLoading}
          >
            <span>{t("submit")}</span>
          </Button>
        </form>
      </div>
      {/* <button className="bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-2 px-4 rounded transition duration-200 w-full sm:w-auto">
                    Edit Profile
                </button> */}
    </SettingSection>
  )
}

export default ChangePasswordComponent
